module.exports = {"420923100":"城关镇","420923101":"义堂镇","420923102":"曾店镇","420923103":"吴铺镇","420923104":"伍洛镇","420923105":"下辛店镇","420923106":"道桥镇","420923107":"隔蒲潭镇","420923108":"胡金店镇","420923200":"倒店乡","420923201":"沙河乡","420923202":"清明河乡","420923450":"县经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420923.json
// module id = 1882
// module chunks = 0